import React from "react";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import FooterLinks from "../components/FooterLinks";
import bannerImage from "../assets/banner4.png";
import { Helmet } from "react-helmet-async";
import "../Site.css";
import "../Home.css"; // Reuse same bullet styles

function About() {
  return (
    <>
      <Helmet>
        <title>PharmPrepPro - About</title>
      </Helmet>

      <BottomContainer>
        <Banner height="300px" image={bannerImage} />

        <BodyContainer>
          <h1 className="white-text center-text-mobile">About Us</h1>
          <p className="white-text subtitle center-text-mobile">
            <strong><em>Empowering today’s pharmacists for tomorrow’s success</em></strong>
          </p>

          <section>
          


            <h2 className="white-text" style={{ marginTop: "14px" }}>Why We Started</h2>
            <p className="white-text">
              Founded in response to the concerning decline in <strong>MPJE®</strong> and <strong>NAPLEX®</strong> scores, 
              we recognized an urgent need to elevate exam preparedness within the pharmacy community.
            </p>
            <p className="white-text">Our team of dedicated educators, industry experts, and passionate practitioners has come together to create high-quality preparatory materials that deliver:</p>
            <ul className="white-text bullet-indent">
              <strong><li>Clarity</li>
              <li>Confidence</li>
              <li>Competence</li></strong>
            </ul>

            <h2 className="white-text" style={{ marginTop: "40px" }}>Our Approach</h2>
            <p className="white-text">We believe that excellence in pharmacy starts with a solid foundation of knowledge.</p>
            <p className="white-text">Our comprehensive:</p>
            <ul className="white-text bullet-indent">
              <strong><li>Study guides</li>
              <li>Practice exams</li>
              <li>Innovative digital learning tools</li></strong>
            </ul>
            <p className="white-text">...are meticulously designed to address the <strong>evolving demands</strong> of modern pharmacy practice.</p>
            <p className="white-text" style={{ marginTop: "14px" }}>Every resource we offer is a product of:</p>
            <ul className="white-text bullet-indent">
              <strong><li>Rigorous academic research</li>
              <li>Real-world expertise</li>
              <li>Our unwavering commitment to your success</li></strong>
            </ul>

            <h2 className="white-text" style={{ marginTop: "40px" }}>Who We Serve</h2>
            <p className="white-text">Whether you’re:</p>
            <ul className="white-text bullet-indent">
              <li>A <strong>recent graduate</strong> seeking your first opportunity, or</li>
              <li>A <strong>seasoned professional</strong> aiming to maintain your edge</li>
            </ul>
            <p className="white-text" style={{ marginTop: "40px" }}><strong>PharmPrepPro</strong> is here to guide you every step of the way toward achieving your <strong>professional goals</strong></p>
          </section>
        </BodyContainer>
      </BottomContainer>

      <FooterLinks />
      <Footer />
    </>
  );
}

export default About;
